// Звук уведомления чата. Учитывает пользовательскую настройку из localStorage
// (тот же ключ, что и тумблер звука в SupportChatWidget)
export const playChatNotificationSound = () => {
  const saved = localStorage.getItem('chatSoundEnabled')
  const soundEnabled = saved !== null ? JSON.parse(saved) : true

  if (!soundEnabled) return

  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)()
    const oscillator = audioContext.createOscillator()
    const gainNode = audioContext.createGain()

    oscillator.connect(gainNode)
    gainNode.connect(audioContext.destination)

    oscillator.frequency.setValueAtTime(800, audioContext.currentTime)
    oscillator.frequency.setValueAtTime(600, audioContext.currentTime + 0.1)

    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime)
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3)

    oscillator.start(audioContext.currentTime)
    oscillator.stop(audioContext.currentTime + 0.3)
  } catch (error) {
    console.log('Звук не может быть воспроизведен:', error)
  }
}
